<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="询问交期"
      class="customer-edit"
      width="500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="delivery"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="要求交期">
        <el-date-picker
            v-model="delivery.deliveryDate"
            align="right"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name:"SalesDeliveryDataEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        delivery: {
          pkid:"",
          deliveryDate:"",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.delivery.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `sd/so/${this.delivery.pkid}`)
          .then(resp => {
            console.log(resp);
            this.delivery = resp;
          });
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "sd/so", this.delivery)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
